import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const openCti = defineConnector({
  identifier: "openCti",
  name: "OpenCTI",
  tagLine: "Threat intelligence platform",
  logo,
  protocol: "http",
  tags: ["security", "data"],
  defaultUrlPattern: ({ instanceUrl }) => urlToPattern(instanceUrl),
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create an OpenCTI API token",
      items: [
        {
          kind: "markdown",
          content:
            "In OpenCTI, create or copy a personal access token, then send it in the `Authorization` header as a bearer token for GraphQL requests.",
        },
      ],
    },
    {
      title: "Enter your OpenCTI details",
      items: [
        {
          kind: "baseUrl",
          label: "OpenCTI base URL",
          required: true,
          placeholder: "https://opencti.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => ({
      url: `${instanceUrl || "https://opencti.example.com"}/public/graphql`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: "query { __typename }" }),
    }),
  },
});
